import React, { useCallback, useMemo } from 'react';
import { Tooltip, useTheme } from '@mui/material';
import { CellTypography } from '@tymely/components';
import { escapeRegExp } from '@tymely/utils';

interface HighlightedTooltipProps {
    value: string;
    filterValue?: string;
}

const HighlightedTooltip: React.FC<HighlightedTooltipProps> = ({ value, filterValue }) => {
    const theme = useTheme();
    const getHighlightText = useCallback((value: string, filterValue: string | undefined) => {
        if (!filterValue || !value.includes(filterValue)) {
            return value;
        }

        const parts = value.split(new RegExp(`(${escapeRegExp(filterValue)})`, 'gi'));
        return parts.map((part, index) =>
            part.toLowerCase() === filterValue.toLowerCase() ? (
                <span key={index} style={theme.customStyles.highlightText}>
                    {part}
                </span>
            ) : (
                part
            ),
        );
    }, []);

    const highlightedText = useMemo(() => getHighlightText(value, filterValue), [value, filterValue, getHighlightText]);
    return (
        <Tooltip title={highlightedText}>
            <CellTypography>{highlightedText}</CellTypography>
        </Tooltip>
    );
};

export default HighlightedTooltip;
